var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLyF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33984 14.8252C8.33984 15.502 8.75879 15.8994 9.44629 15.8994H15.0322C15.7197 15.8994 16.1494 15.502 16.1494 14.8252V9.16406C16.1494 8.49805 15.7197 8.08984 15.0322 8.08984H9.44629C8.75879 8.08984 8.33984 8.49805 8.33984 9.16406V14.8252Z",
    fill: "#D32029"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 23.0967C6.12695 23.0967 1.15332 18.123 1.15332 12C1.15332 5.87695 6.12695 0.90332 12.25 0.90332C18.373 0.90332 23.3467 5.87695 23.3467 12C23.3467 18.123 18.373 23.0967 12.25 23.0967ZM21.166 12C21.166 16.9307 17.1807 20.9053 12.25 20.9053C7.31934 20.9053 3.33398 16.9307 3.33398 12C3.33398 7.06934 7.31934 3.08398 12.25 3.08398C17.1807 3.08398 21.166 7.06934 21.166 12Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyF);
export default __webpack_public_path__ + "static/media/ly_f.7668e16019404eee7ae88d77c5f28ab1.svg";
export { ForwardRef as ReactComponent };